import React from "react";
import CertificateInfo from "./CertificateInfo";
import CurrencySelector from "./CurrencySelector";
import DaySelector from "./DaySelector";

const PricesAndOffersHeader = ({
  villa,
  currency,
  setCurrency,
  days,
  setDays,
}) => {
  return (
    <div>
      <span className="text-xl font-bold leading-normal text-themeBlack md:text-2xl">
        Fiyatlar & Fırsatlar
      </span>
      <div className="flex flex-col items-center justify-between gap-3 mt-4 mb-3 md:flex-row lg:gap-5 lg:mb-10 md:mb-5">
        <div className="flex items-center justify-between gap-2 sm:gap-3">
          <CurrencySelector currency={currency} setCurrency={setCurrency} />
          <DaySelector days={days} setDays={setDays} />
        </div>
        <CertificateInfo villa={villa} />
      </div>
    </div>
  );
};

export default PricesAndOffersHeader;
